export function createMixLayout({ head, torso, legs, head2, isPixelMixer = false }) {
  if (!head || !torso || (isPixelMixer && !legs)) return null;
  const torsoLayer = { part: torso, x: 0, y: 0 };
  const headLayer = { part: head, x: torso.headanchorx - head.headanchorx, y: torso.headanchory - head.headanchory };
  const headBehind = !isPixelMixer && (
    torso.headBehindTorso || ['mccree', 'zenyatta', 'ramattra'].includes(torso.id)
    || ['widowmaker', 'symmetra', 'dva'].includes(head.id)
  ) && !(torso.id === 'mccree' && head.id === 'torbjorn');
  const layers = headBehind ? [headLayer, torsoLayer] : [torsoLayer, headLayer];
  if (isPixelMixer) layers.push({ part: legs, x: torso.leganchorx - legs.leganchorx, y: torso.leganchory - legs.leganchory });
  if (torso.id === 'ashe' && head2) layers.push({ part: head2, x: torso.head2anchorx - head2.headanchorx, y: torso.head2anchory - head2.headanchory });
  const left = Math.floor(Math.min(...layers.map(p => p.x)));
  const top = Math.floor(Math.min(...layers.map(p => p.y)));
  const right = Math.ceil(Math.max(...layers.map(p => p.x + p.part.width)));
  const bottom = Math.ceil(Math.max(...layers.map(p => p.y + p.part.height)));
  return { width: right - left, height: bottom - top, layers: layers.map(p => ({ ...p, x: p.x - left, y: p.y - top })) };
}

export function readMixSelection(search, data, isPixelMixer, random = Math.random) {
  const params = new URLSearchParams(search);
  const choose = (key, type) => {
    const candidates = data.filter(p => p.type === type);
    return candidates.find(p => p.num === Number(params.get(key))) || candidates[Math.floor(random() * candidates.length)];
  };
  const head = choose('h', 'head');
  const torso = choose('t', 'torso');
  const head2 = torso.id === 'ashe' ? choose('h2', 'head') : null;
  const legs = isPixelMixer ? choose('l', 'legs') : null;
  return {
    head: head.id, headParam: head.num, torso: torso.id, torsoParam: torso.num,
    head2: head2 ? head2.id : '', head2Param: head2 ? head2.num : null, isAshe: torso.id === 'ashe',
    ...(legs ? { legs: legs.id, legsParam: legs.num } : {}),
  };
}
